// extracted by mini-css-extract-plugin
export default {"bottomBar":"CryptoTaxes_bottomBar__JMya8"};